module.exports = __webpack_public_path__ + "img/layout-sidebar-inset.beac9110.svg";